/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 27/01/22
 */

import { Alert, AlertDescription, AlertIcon, AlertProps, AlertTitle, Box } from '@chakra-ui/react';
import { HTMLChakraProps } from '@chakra-ui/system';
import React, { ReactNode } from 'react';

export interface SimpleAlertProps extends HTMLChakraProps<'div'> {
    title?: string;
    variant: AlertProps['variant'];
    status?: AlertProps['status'];
    children: ReactNode;
}

export const SimpleAlert = (props: SimpleAlertProps) => {
    const { variant, title, children, status = 'error', ...otherProps } = props;
    const radius = 6;
    const rounding: Partial<Pick<AlertProps, 'roundedRight' | 'rounded' | 'roundedBottom'>> = {};
    switch (variant) {
        case 'left-accent':
            rounding['roundedRight'] = radius;
            break;
        case 'top-accent':
            rounding['roundedBottom'] = radius;
            break;
        default:
            rounding['rounded'] = radius;
            break;
    }
    return (
        <Alert status={status} variant={variant} w={'100%'} {...rounding} {...otherProps}>
            <AlertIcon />
            <Box flex="1" alignItems="flex-start">
                {title && <AlertTitle>{title}</AlertTitle>}
                <AlertDescription>{children}</AlertDescription>
            </Box>
        </Alert>
    );
};
